import client from '../../base-api';

const serviceURL = '/unemployed/private-coaching';
const inquiryServiceURL = '/unemployed/private-coaching-inquiry';

const privateCoachingService = {
    // Regular
    getPrivateCoachingList(unemployedId: number) {
        return client.get(`${serviceURL}/${unemployedId}`);
    },
    getPrivateCoaching(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },
    postPrivateCoaching(coachingData: any) {
        return client.post(`${serviceURL}`, coachingData);
    },
    putPrivateCoaching(coachingData: any, coachingId: number) {
        return client.put(`${serviceURL}/${coachingId}`, coachingData);
    },
    deletePrivateCoaching(coachingId: number) {
        return client.delete(`${serviceURL}/delete/${coachingId}`);
    },
    approveModules(moduleIds: any, coachingId: number) {
        return client.put(`${serviceURL}/approve-modules/${coachingId}`, moduleIds);
    },

    // Inquiry
    postInquiryPrivateCoaching(inquiryData: any) {
        return client.post(`${inquiryServiceURL}`, inquiryData);
    },
    putInquiryPrivateCoaching(inquiryData: any, coachingId: number) {
        return client.put(`${inquiryServiceURL}/${coachingId}`, inquiryData);
    },
    getInquiryClientData(clientId: number) {
        return client.get(`${inquiryServiceURL}/client-data/${clientId}`);
    },
    getInquiryCoachesFromLocations(locationIds: any) {
        return client.post(`${inquiryServiceURL}/coaches`, locationIds);
    },
    getInquiryOverviewListForCoach(filterData: any) {
        return client.get(`${inquiryServiceURL}/list-for-coach`, {params: filterData});
    },
    countInquiryNotificationsForCoach() {
        return client.get(`${inquiryServiceURL}/count-notification-for-coach`);
    },
    acceptInquiry(coachingId: number, coachId: number) {
        return client.put(`${inquiryServiceURL}/accept/${coachingId}/${coachId}`);
    },


    // --- Digital Documents ----
    postDigitalDocuments(documentsData: any) {
        return client.post(`${serviceURL}/digital-documents`, documentsData);
    },
    editDigitalDocuments(documentsData: any, documentUuid: string) {
        return client.put(`${serviceURL}/digital-documents/${documentUuid}`, documentsData);
    },
    deleteDigitalDocuments(documentUuid: string) {
        return client.delete(`${serviceURL}/digital-documents/${documentUuid}`);
    },
    getDigitalDocuments(unemployedId: number) {
        return client.get(`${serviceURL}/${unemployedId}/digital-documents`);
    },
    assignedCoachingToDigitalDocuments(documentUuid: string, coachingId: string) {
        return client.put(`${serviceURL}/digital-documents/assign-coaching/${documentUuid}/${coachingId}`);
    },


    // Selection interview
    getSelectionInterview(documentId: string | number) {
        return client.get(`${serviceURL}/digital-documents/selection-interview/${documentId}`);
    },
    saveSelectionInterview(documentId: string | number, data: any) {
        return client.post(`${serviceURL}/digital-documents/selection-interview/${documentId}`, data);
    },
    // Further training
    getFurtherTrainingContract(documentId: string | number) {
        return client.get(`${serviceURL}/digital-documents/further-training-contract/${documentId}`);
    },
    saveFurtherTrainingContract(documentId: string | number, data: any) {
        return client.post(`${serviceURL}/digital-documents/further-training-contract/${documentId}`, data);
    },
    // Health questionnaire
    getHealthQuestionnaire(documentId: string | number) {
        return client.get(`${serviceURL}/digital-documents/health-questionnaire/${documentId}`);
    },
    saveHealthQuestionnaire(documentId: string | number, data: any) {
        return client.post(`${serviceURL}/digital-documents/health-questionnaire/${documentId}`, data);
    },

    // Signature
    saveDigitalSignature(documentId: string, data: any) {
        return client.post(`${serviceURL}/digital-documents/signature/${documentId}`, data);
    },
    getDigitalSignature(documentId: string) {
        return client.get(`${serviceURL}/digital-documents/signature/${documentId}`);
    }

}

export default privateCoachingService;